<template>
  <div class="laddercontrol-banner">
    <img :src="laddercontrolBanner" alt="" />
    <div class="absolute">
      <div class="title">智能梯控</div>
      <div class="text">智能梯控系统是一种电梯控制技术，在原有的电梯上安装一个类似“门禁”的系统装置，通过刷卡、刷脸等智能识别方式电梯才会启动，将业主送到其要达到的楼面</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import laddercontrolBanner from "../../../../assets/programme/laddercontrolBanner.png";

export default {
  setup() {
    return reactive({
      laddercontrolBanner: laddercontrolBanner,
      experienceShow: false,
    });
  },
   components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.laddercontrol-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .laddercontrol-banner {
    min-width: 1180px;
  }
}
.laddercontrol-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248EFB;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248EFB;
}
.absolute .experience {
  margin-top: 40px;
  font-size: 16px;
  color: #248EFB;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248EFB;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
